import './SavedQuotesTab.css';

const SavedQuotesTab = ({ savedQuoteCards }) => {
    return ( 
            <>
                <div >
                    {savedQuoteCards}
                </div>
            </>
     );
}
 
export default SavedQuotesTab;